var CampaignView = require('./views/campaign');
var FindContentView = require('./views/find-content');
var SimpleMessageAlert = require('./views/simple-message-alert');
var FeatureView = require('./views/feature');

var Inits = {};

  // EtcController
  Inits.Etc = {
    // この引数のvarsにjs_varsの値が入ってくる。
    index: function(vars) {
      var question_load = new App.Views.QuestionLoad();
      // LocalStorageがないAndroidのバージョン(v1.6.0以前)で
      // jsが動かなくなるのでLocalStorageが使用できるかチェックする
      if (localStorage !== null) {
        var birthday_popup_banner = new App.Views.BirthdayPopupBanner();
        var birthday_popup_set    = new App.Views.BirthdayPopupSet();
        var birthday_popup_remind = new App.Views.BirthdayPopupRemind();
      }
    },
    faq: function() {
      // 多重送信防止用の一意な ID を生成する
      const transactionId = `${Date.now()}${Math.floor(Math.random() * 1000000)}`

      $('.faq-question').on('click', function() {
        const target = $(this)
        mixpanel.track('FaqListItemClick', {
          SectionName: target.data('sectionName'),
          ArticleTitle: target.data('articleTitle')
        })
        tracker.track('FaqListItemClick', {
          transaction_id: transactionId,
          SectionName: target.data('sectionName'),
          ArticleTitle: target.data('articleTitle')
        })

        target.next().slideToggle();
        target.parent('.faq-list').toggleClass('opened');
      });

      // アンカーリンクがついていたらアコーディオンを開いておく
      if (location.hash) {
        $(`${location.hash}.faq-list`).children('.faq-question').click()
      }
    },
    social: function(vars) {
      var social_point_add = new App.Views.SocialPointAdd();
    },
    firstQuestionContent: function(vars) {
      var question_add = new App.Views.QuestionAdd();
    },
    pointCampaign: function() {
      new App.Views.PointCampaignApply();
    },
    pointCampaignApply: function() {
      var seminar_campaign_apply = new App.Views.SeminarCampaignApply();
    },
  };

  // QuestionsController
  Inits.Questions = {
    add: function() {
      new App.Views.QuestionAdd();
    },
    category: function() {
      new App.Views.QuestionLoad();
    },
    region: function() {
      // 都道府県設定済みの場合のみ利用可能
      if (App.me.User.prefecture_id) {
        new App.Views.QuestionLoad();
      }
    },
    unanswered: function() {
      new App.Views.QuestionLoad();
    },
    show: function() {
      var question_scroll_header = new App.Views.QuestionScrollHeader();
      new App.Views.QuestionDelete();
      new App.Views.ReveilSensitiveImage();
      new App.Views.AnswerAdd();
      new App.Views.AnswerDelete();
      new App.Views.LikeAdd();
      new App.Views.ThankAdd();
      new App.Views.BestAnswerAdd();
      new App.Views.Favorite();
      new App.Views.ViolationReport();

      // キャンペーンの詳細を表示する
      $(".js-campaign-read-more").click(function() {
        var $btn     = $(this);
        var $content = $('.js-campaign-expand-content');
        $content.slideToggle(500);
        $btn.fadeOut('fast');
        mixpanel.track('CampaignReadMore');
      });

      // LocalStorageがないAndroidのバージョン(v1.6.0以前)で
      // jsが動かなくなるのでLocalStorageが使用できるかチェックする
      if (localStorage !== null) {
        var infinity_scroll = new App.Views.QuestionInfinityScroll();
        // 無限スクロールの記事除外リストへ現在のQuestion.idを追加
        infinity_scroll.pushExcludeQuestionList($('.infinity-scroll-content-wrapper:first').data('questionId'));
      }

      // グッドアンサーが存在していたら、そのグッドアンサー以外を隠す
      if ($(".best-answer-selected").size() !== 0) {
          $(".best-answer").hide();
      }

      // 下へスクロール
      $(".link-to-bottom").click(function() {
          var $current_content_wrapper, $answer_footer, scroll_to;
          $current_content_wrapper = $(this).closest('.infinity-scroll-content-wrapper');
          $answer_footer           = $current_content_wrapper.find('.answer__footer');
          scroll_to                = $answer_footer.offset().top + $answer_footer.height() + 10 - $(window).height();
          scroll_to                = Math.min(scroll_to, $answer_footer.offset().top);
          $('html,body').animate({scrollTop: scroll_to}, { duration: 'slow', easing: 'swing'});
      });
      // 上へスクロール
      $(".link-to-top").click(function() {
        var $current_content_wrapper, scroll_to;
        $current_content_wrapper = $(this).closest('.infinity-scroll-content-wrapper');
        scroll_to                = $current_content_wrapper.offset().top - 10;
        $('html,body').animate({scrollTop: Math.max(0, scroll_to)}, {duration: 'slow', easing: 'swing'});
      });

      var $current_content, current_question_id, isFixedHeaderAvailable, prev_question_id;
      isFixedHeaderAvailable = function($current_content) {
        var answer_offset_bottom, question_offset_top;
        answer_offset_bottom   = $current_content.find('.answer').offset().top +  $current_content.find('.answer').height();
        question_offset_top = $current_content.find('.question-show__content-wrapper').offset().top;
        return (question_offset_top <= window.scrollY) && ((answer_offset_bottom - 42) >= window.scrollY);
      };

      $(window).on({
        'scroll touchmove': function(event) {
          var $next_target_anchor, $placeholder, $question_wrapper, bottom_line_y, next_content, next_target, wrapper_class_name, view_area_middle;
          // 次の記事が1度も指定されていない=無限スクロールに対応していないのでreturnする
          if ($('.infinity-scroll-next-anchor').length === 0) {
            return;
          }

          view_area_middle   = window.scrollY + (window.innerHeight / 2);
          wrapper_class_name = 'infinity-scroll-content-wrapper';

          // 無限スクロール
          $question_wrapper = $('.' + wrapper_class_name).last();
          // 先に読み込んだ記事の処理が終わっているかチェック
          if ($question_wrapper.data('isLoading')) {
            return;
          }

          // 「回答募集中の質問」の近くまできたら発火
          bottom_line_y = $question_wrapper.find('.other-questions-wrapper').offset().top;
          if ((window.scrollY + screen.height) > bottom_line_y - screen.height) {
            $next_target_anchor = $('.infinity-scroll-next-anchor', $question_wrapper);
            if ($next_target_anchor.length) {
              next_target  = $next_target_anchor.attr('href');
              $placeholder = $('<div><div class="infinity-scroll-content--loading"><img class="infinity-scroll-content--loading__img" src="//cdn.mamari.jp/static/mamariQ/img/common/loadimg_bottom.gif"></div></div>').addClass(wrapper_class_name);
              $placeholder.data('isLoading', true);
              $question_wrapper.after($placeholder);
              next_content = new App.Views.QuestionInfinityScroll();
              next_content.appendQuestion(event, next_target);
            }
          }

          $('.' + wrapper_class_name).each( function() {
            var $next_content, next_content_top;

            $next_content = $(this).next('.' + wrapper_class_name);
            if (! $next_content.length) {
              $current_content = $(this);
              return false;
            }

            next_content_top    = $next_content.offset().top;

            // このコンテンツが画面の半分以上を占めているとき
            if ((next_content_top + 20) < view_area_middle) {
              $current_content = $next_content;
              return true;
            }
            $current_content = $(this);
            return false;
          });
          current_question_id = $current_content.data('questionId');

          if (prev_question_id !== current_question_id) {
            prev_question_id                   = current_question_id;
            question_scroll_header.question_id = current_question_id;
            question_scroll_header.render($current_content.find('.question-show__header'));
            location.href = 'mamariq://update_question_id?question_id=' + current_question_id;
          }
          if (isFixedHeaderAvailable($current_content)) {
            question_scroll_header.show();
          } else {
            question_scroll_header.hide();
          }
        }
      });

      /* Answerへのスクロール */
      var queries, query_pair, query_pairs;
      queries     = [];
      query_pairs = location.search.substring(1).split('&');
      for (var i = 0; i < query_pairs.length; i++) {
        query_pair             = query_pairs[i].split('=', 2);
        queries[query_pair[0]] = query_pair[1];
      }
      // Answerの情報があればスクロールする
      if ('answer_id' in queries) {
        var $answer, answer_id, scroll_to;
        answer_id = queries.answer_id;
        $answer   = $('#answer-' + answer_id);
        if ($answer.length) {
          scroll_to = $answer.offset().top - 45;
          $('html,body').animate({scrollTop: Math.max(0, scroll_to)}, {duration: 'slow', easing: 'swing'});
        }
      }

      // キャンペーンのポップアップを表示すべきか値があれば表示する
      if (App.me.is_login && App.vars.should_show_popup === true) {
        new App.Views.CampaignAddressInputPopup({
          attributes: { campaignId: App.vars.campaign_id }
        }).show();
      }
    }
  };

  // UsersController
  Inits.Users = {
    answers: function(vars) {
      var question_load = new App.Views.QuestionLoad();
    },
    favorites: function(vars) {
      var question_load = new App.Views.QuestionLoad();
    },
    favoriteArticles: function(vars) {
      var article_load = new App.Views.FavoriteArticleLoad();
    },
    followTags: function(vars) {
      var follow_tag = new App.Views.FollowTag();
      var tag_search = new App.Views.TagSearch();
    },
    questions: function(vars) {
      var question_load = new App.Views.QuestionLoad();
    },
    blocking: function(vars) {
      var blocking_user_list = new App.Views.BlockingUserList();
    },
    settings: function(vars) {
      var user_settings = new App.Views.UserSettings();
      var category_show_settings = new App.Views.CategoryShowSettings();
    },
    show: function(vars) {
      var category_show_settings = new App.Views.CategoryShowSettings();
      var block = new App.Views.Block();
    },
    unregister: function(vars) {
      var unregister = new App.Views.Unregister();
    },
    mypage: function(vars) {
      // LocalStorageがないAndroidのバージョン(v1.6.0以前)で
      // jsが動かなくなるのでLocalStorageが使用できるかチェックする
      if (localStorage !== null) {
        var birthday_popup_banner = new App.Views.BirthdayPopupBanner();
        var birthday_popup_set    = new App.Views.BirthdayPopupSet();
        var birthday_popup_remind = new App.Views.BirthdayPopupRemind();
      }

      // 誕生日を入力するかconfirmを表示する
      $('.js-birthday-set-confirm-btn').on('click', function() {
        var confirm = new App.Views.BirthdaySetConfirm({ childId: $(this).data('childId') }).render();
        confirm.show();
      });
    },
    sleepTime: function(vars) {
      var sleep_time_settings = new App.Views.SleepTimeSettings();
    },
    myFavorites: function() {
      // track: お気に入りコンテンツ選択
      $('.js-favorite-content').on('click', function() {
        var $element = $(this);
        mixpanel.track('FavoriteContentShow', {
          ContentType: $element.data('type'),
          ContentId: $element.data('id')
        });
      });
      // track: 一覧ページ
      $('.js-favorite-read-more').on('click', function() {
        var $element = $(this);
        mixpanel.track('FavoriteContentReadMore', { ContentType: $element.data('type') });
      });
    },
    transfer: () => {
      $('.js-app-update-alert').click(() => {
        alert('アプリのバージョンが古くなっているため表示できません。アプリを最新版にアップデートして再度お試しください。')
      })
    }
  };

  // TagsController
  Inits.Tags = {
    show: function(vars) {
      var question_load = new App.Views.QuestionLoad();
      var follow_tag    = new App.Views.FollowTag();
    },
    follows: function() {
      App.Views.simpleMessageAlert = new SimpleMessageAlert();
      new App.Views.TagSearch();
      var is_btn_closed = localStorage.getItem('followTagFaqLinkClose');

      // フォローページ導線リンクのとじるボタン
      if(is_btn_closed) { // ボタンが１度押されたことがある場合は表示しない
        $(".p-follow-tag-faq-link").css("display", "none");
      }
      // とじるボタンをタップしたらリンクを消す
      $(".p-follow-tag-faq-link__close").click(function() {
        $(".p-follow-tag-faq-link").hide();
        localStorage.setItem('followTagFaqLinkClose', true);
      });
    },
    search: function(vars) {
      var follow_tag = new App.Views.FollowTag();
      var tag_search = new App.Views.TagSearch();
    },
  };

  // WebQuestionsController
  Inits.WebQuestions = {
    show: function() {
      // 下へスクロール
      $(".link-to-bottom").click(function() {
        var answer_height_bottom = $(".q-main-answer").height() + $(".q-main-answer").offset().top - $(window).height();
        $('html,body').animate({ scrollTop: answer_height_bottom }, { duration: 'slow', easing: 'swing'});
      });

      // 上へスクロール
      $(".link-to-top").click(function() {
        var answer_height_top = $(".q-main-answer").offset().top;
        $('html,body').animate({ scrollTop: answer_height_top }, { duration: 'slow', easing: 'swing'});
      });

    }
  };

  // WebEtcController
  Inits.WebEtc = {
    fpReserve: function () {
      new App.Views.FpReserve();
    }
  };

  // NotificationsController
  Inits.Notifications = {
    index: function(vars) {
      var notification_mark_as_read = new App.Views.NotificationMarkAsRead();
      var announcement_load = new App.Views.AnnouncementLoad();
    }
  };

  // AnnouncementsController
  Inits.Announcements = {
    index: function(vars) {
      var announcement_load = new App.Views.AnnouncementLoad();
    }
  };

  // ArticlesController
  Inits.Articles = {
    index: function() {
      App.Views.simpleMessageAlert = new SimpleMessageAlert();
      new App.Views.ArticleSearchForm();
      new App.Views.ArticleTop();
      new App.Views.ArticleLoad();
    }
  };

  // FeaturesController
  Inits.Features = {
    index: function() {
      const features = new FeatureView.FeatureList()

      $(window).on('scroll touchmove', function() {
        const scrollHeight = $(document).height()
        const scrollPosition = $(window).height() + $(window).scrollTop()
        const diff = scrollHeight - scrollPosition
        if (diff < 600 && diff !== 0) {
          features.load()
        }
      })
    }
  }

  // FindContentsController
  Inits.FindContents = {};

  Inits.FindContents.handleSearchSubmit = function() {
    var form = $('.js-search-form');
    // 検索時にuuidを付与する
    form.on('submit', function() {
      var query = $('.js-request-query').val();
      if (_.isEmpty(query)) {
        alert('検索したいワードを入力してください');
        return false;
      }

      mixpanel.track('ContentSearch', { 'Query': query });
      if (App.me.is_android) {
        // androidはそのまま送信
        return;
      }

      // iOSはaタグを生成してクリックする
      $('<a/>', {
        href: form.attr('action') + '?q=' + encodeURIComponent(query)
      }).get(0).click();
      // submitはキャンセルする
      return false;
    });
  };

  Inits.FindContents.handleContentClick = function() {
    // おすすめタグタップ
    $('.js-recommended-tag').on('click', function() {
      mixpanel.track('ContentSearchRecommendedTag', { 'Query': $(this).data('query') })
      mixpanel.track('FindContentShow', { 'ContentType': 'Pickup' })
    })

    // 各コンテンツのタップ
    $('.js-show-content').on('click', function() {
      mixpanel.track('FindContentShow', { 'ContentType': $(this).data('contentType') })
    })
  }

  Inits.FindContents.index = function() {
    Inits.FindContents.handleSearchSubmit();
    Inits.FindContents.handleContentClick();

    // @link https://github.com/kenwheeler/slick/blob/master/README.markdown
    var carousel = $('.js-carousel-list').slick({
      arrows: false,
      autoplay: false,
      autoplaySpeed: 3000,
      infinite: true,
      speed: 250
    });
    // 崩れるのでスタイル当てたら表示
    carousel.show();

    // サーバサイドで1P目がすでに描画されているので2P目から始める
    var articles = new FindContentView.Articles({
      apiPath: '/api/article/trend.json',
      page: 2,
      limit: 20,
      template: require('../../hbs/trend_article.hbs')
    });
    $(window).on('scroll touchmove', function() {
      var scrollHeight = $(document).height();
      var scrollPosition = $(window).height() + $(window).scrollTop();
      if (scrollHeight - scrollPosition < 600) {
        articles.load();
      }
    });
  };

  Inits.FindContents.articles = function() {
    Inits.FindContents.handleContentClick();
  };

  Inits.FindContents.tags = function() {
    Inits.FindContents.handleContentClick();
  };

  Inits.FindContents.search = function() {
    Inits.FindContents.handleSearchSubmit();

    new FindContentView.Tags().load();

    var data = { q: $('.js-article-area').data('query') };
    var articles = new FindContentView.Articles({
      apiPath: '/api/article/search.json',
      template: require('../../hbs/find_article.hbs')
    });
    articles.load(data);
    $(window).on('scroll touchmove', function() {
      var scrollHeight = $(document).height();
      var scrollPosition = $(window).height() + $(window).scrollTop();
      if (scrollHeight - scrollPosition < 450) {
        // 初回読み込み中でない and 残スクロールエリアが規定値未満
        articles.load(data);
      }
    });
  };

  // HospitalReviewsController
  Inits.HospitalReviews = {
    add: function(vars) {
      var HospitalReviewAddForm = new App.Views.HospitalReviewAddForm();
    },
    addSearch: function(vars) {
      var HospitalReviewAddSearchForm = new App.Views.HospitalReviewAddSearchForm();
    }
  };

  // CampaignsController
  Inits.Campaigns = {
    show: function() {
      new CampaignView.CampaignComment()
    }
  }
module.exports = Inits;



// WEBPACK FOOTER //
// ./webroot/js/sp/init.js